<template>
    <div>
      <patent-note-type-list></patent-note-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  